import styled from "@emotion/styled";
export const StyledResourcesMenuComponent = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: row;
  gap: 0;

  .menu-section {
    display: flex;
    flex-direction: column;
    gap: 48px;
    flex: 1;
    min-width: 0;

    .links {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .mini-link-item {
        color: #000000;

        .text {
          color: #000000;
        }
      }
    }
  }
`;
